/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_ExtractingInputs */



/**
* | output |
* | --- |
* | "Extracting captions..." |
*
* @param {Subtitle_Extract_ExtractingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_extracting = /** @type {((inputs?: Subtitle_Extract_ExtractingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_ExtractingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction des légendes...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel werden extrahiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione delle didascalie...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечение подписей...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extrayendo subtítulos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在提取字幕……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕を抽出しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन निकाले जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extraindo legendas...")
	return /** @type {LocalizedString} */ ("Extracting captions...")
});